import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import {SlotsTable} from '../../../components/Tables/Slots';
import useStyles from '../../styles';
import {translateVehicle, translateStatus} from '../../../components/Tables/utils';

const Description = ({
  data,
  detailData: {
    vehicleId,
    status
  },
  setPath,
  isBusy
}) => {

  const classes = useStyles();

  return <Grid container justify='space-around' align='center'>

    <Grid item xs={12}>
      <Typography className={classes.text}>
        {`Veículo: ${translateVehicle(vehicleId)}`}
      </Typography>
    </Grid>

    <Grid item xs={12}>
      <Typography className={classes.text}>
        {`Status: ${translateStatus(status)}`}
      </Typography>
    </Grid>

    <Grid item xs={12}>
      <SlotsTable
        {...{data, isBusy}}
      />
    </Grid>

    {
      vehicleId !== 'none' &&
        <Grid item>
          <Button color='primary' onClick={() => setPath('init')}>
            Iniciar
          </Button>
        </Grid>
    }

    <Grid item>
      <Button color='secondary' onClick={() => setPath('root')}>
        Fechar
      </Button>
    </Grid>

  </Grid>
};

export default Description;
